<template lang="html">
 <v-dialog v-model="dialogEditpictureprofile" persistent max-width="500px">
    <v-card style="border-radius:20px;">
      <v-card tile>
        <v-toolbar card style="background: #1a222c !important;">
          <v-toolbar-title class="white--text CSChatThai" style="white-space: nowrap; width: 100%; overflow: hidden; text-overflow: ellipsis;">
           <span class="headline CSChatThai" >
              <v-icon color="white">mdi-tooltip-image</v-icon>&nbsp;&nbsp;{{$t('Dialog.pictureProfile')}}
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog">
            <v-icon style="color: white !important; font-size: 25px !important;">clear</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card>
      <v-card-text style="margin-top:0vh; margin-bottom:0vh; justify-content: center !important;">
        <v-container grid-list-md style="padding: 20px !important; padding-top: 10px !important;padding-bottom: 10px !important;">
          <v-layout wrap>
            <v-flex sm12 md12 lg12 xl12 >
              <!-- {{profilepicture}} -->
              <vue-avatar
                :width="400"
                :height="400"
                :rotation="rotation"
                :scale="scale"
                :border="0"
                ref="vueavatar"
                style="text-align: center;"
                @vue-avatar-editor:image-ready="onImageReady"
                :image="profilepicture"
                >
              </vue-avatar>
              <br>
              <v-slider
                v-model="scale"
                label="Zoom :"
                min=1
                max=3
                step=0.02
                thumb-label="always"
                ticks
              ></v-slider>
              <v-slider
                v-model="rotation"
                label="Rotation :"
                min=0
                max=360
                step=1
                thumb-label="always"
                ticks
              ></v-slider>
              <v-spacer></v-spacer>
              <v-btn flat small dark class="button_cancel" @click="closeDialog" style="float: right;">{{$t('AnswerQuestion.cancel')}}</v-btn>
              <v-btn flat small dark class="buttonedit" @click="saveClicked" style="float: right;">{{$t('AnswerQuestion.keep')}}</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
// import VueAvatar from '@/components/VueAvatar';
// import adapter from 'webrtc-adapter'
import { Decode } from '@/services'
import {VueAvatar} from 'vue-avatar-editor-improved'
import { sync } from 'vuex-pathify'

export default {
  props: {'dialogEditpictureprofile': false},
  data: () => ({
    // return {
    //   constraints: window.constraints = {
    //     audio: false,
    //     video: true
    //   },
    rotation: 0,
    scale: 1,
    profilepicture: ''
    // infor_image: {}
    // }
  }),
  components: {
    VueAvatar
  },
  computed: {
    ...sync('*')
  },
  watch: {
    myprofilepicture () {
      this.profilepicture = localStorage.getItem('profilepicture')
    },
    dialogEditpictureprofile () {
      if (this.dialogEditpictureprofile) {
        this.$refs.vueavatar.loadImage(this.profilepicture)
      }
    }
  },
  methods: {
    closeDialog () {
      // this.onImageReady()
      var canvas = document.getElementById('avatarEditorCanvas')
      var context = canvas.getContext('2d')
      context.clearRect(0, 0, canvas.width, canvas.height)
      this.$refs.vueavatar.redraw()
      this.scale = 1
      this.rotation = 0
      this.$refs.vueavatar.imageChanged()
      this.$emit('closeEditpictureprofile', false)
    },
    saveClicked () {
      var img = this.$refs.vueavatar.getImageScaled()
      var me = this
      var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
      // this.token = decoded['tokenuser']
      img.toBlob(function(blob) {
        var uploadFile = new FormData()
        uploadFile.append('file', blob, 'filename.png');
        uploadFile.append('tokenuser', decoded['tokenuser'])
        uploadFile.append('type_user', 'user')
        me.axios.post(process.env.APIgo_api + '/v1/set-picture-profile', uploadFile).then((response) => {
          if (response.data.status === 'success') {
            me.profilepicture = response.data.filename
            localStorage.setItem('profilepicture', response.data.filename)
            me.myprofilepicture = response.data.filename
            me.closeDialog()
          }
        })
      });
    },
    onImageReady () {
      this.scale = 1
      this.rotation = 0

    }
  },
  created () {
    this.profilepicture = localStorage.getItem('profilepicture')
  }
}
</script>

<style lang="css" scoped>
>>>canvas {
  width: 200px !important;
  height: 200px !important;
  border: 3px #1a222b solid;
  border-radius: 20px;
}
.buttonedit {
  color: ghostwhite;
  border-radius: 4px;
  background-color: #2562af !important;
  border: solid 1px #2562af !important;
  -webkit-box-sizing: border-box !important;
  box-sizing: border-box !important;
  margin-right: 0 !important;
  text-align: center;
  font-weight: 400 !important;
  text-transform: none;
}
.button_cancel {
  color: ghostwhite;
  border-radius: 4px;
  background-color: #f51414b3 !important;
  border: solid 1px #f51414b3 !important;
  -webkit-box-sizing: border-box !important;
  box-sizing: border-box !important;
  margin-right: 0 !important;
  text-align: center;
  font-weight: 400 !important;
  text-transform: none;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/dialog/settings/Editpictureprofile.vue